import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from '../../app/store';
import { copy } from '../../services/util';
import { skillShareUtil } from './skillShareUtil';
import { SkillTrainerState } from './skillTrainerSlice';

const initialState: SkillShareState = {
  visible: false
};

export interface SkillShareState {
  visible: boolean
};

export const encodeBuild = (): AppThunk<string> => (_, getState) => {
  return skillShareUtil.encode(getState());
};

export const decodeBuild = (code: string): AppThunk => (dispatch) => {
  const state = skillShareUtil.decode(code);
  dispatch(slice.actions.decodeBuildFulfilled(state));
}

export const copyUrl = (url: string): AppThunk => (dispatch) => {
  copy(url);
  dispatch(slice.actions.hide());
}

export const slice = createSlice({
  name: 'skillShare',
  initialState: initialState,
  reducers: {
    show: (state) => {
      state.visible = true;
    },
    hide: (state) => {
      state.visible = false;
    },
    decodeBuildFulfilled: (state, action: PayloadAction<SkillTrainerState>) => {
      //
    }
  }
});

export default slice.reducer;
export const { show, hide, decodeBuildFulfilled } = slice.actions;
